export default (state = {
    testPackList: [],
    allTestPack: [],
    totalItems: 0,
    currentPage: 1,
    pageCount: 1,
    pageSize: localStorage.getItem("testPackPageSize") ? Number(localStorage.getItem("testPackPageSize")) : 30
}, action) => {
    switch (action.type) {
        case "SET_TEST_PACK":
            return {
                ...state,
                testPackList: action.payload,
                // currentPage: action.currentPage,
                sortBy: action.sortBy,
                sortOrder: action.sortOrder,
                totalItems: action.totalItems,
                pageCount: action.pageCount || 1,
            }
        case "SET_ALL_TEST_PACK":
            return {
                ...state,
                allQuestionCategory: action.payload
            }
        case "CHANGE_PAGE_SIZE_TEST_PACK":
            return {
                ...state,
                pageSize: action.payload
            }
        case "CHANGE_CURRENT_PAGE_TEST_PACK":
            return {
                ...state,
                currentPage: action.payload
            }
        default:
            return state
    }
}